/** The menu and the frame around every page — English, the source of the other languages */
const nav = {
  "nav.overview": "Overview",
  "nav.admins": "Admins",
  "nav.models": "Models",
  "nav.companies": "Companies",
  "nav.settings": "Settings",
  "nav.vpn": "VPN",
  "nav.edge": "Edge proxy",
  "nav.licensePlans": "Licence plans",
  "nav.licenseOverview": "Licence overview",
  "nav.myProfile": "My profile",
  "nav.dashboard": "Dashboard",
  "nav.monitoring": "Monitoring",
  "nav.alerts": "Alerts",
  "nav.sites": "Sites",
  "nav.templates": "Templates",
  "nav.users": "Users",
  "nav.roles": "Roles",
  "nav.branding": "Branding",
  "nav.messages": "Messages",
  "nav.apiKeys": "API keys",
  "nav.webhooks": "Webhooks",
  "nav.notifications": "Notifications",
  "nav.roleGlobalAdmin": "Global admin",
  "nav.roleAdmin": "Admin",
  "nav.roleUser": "User",
  "nav.switchCompany": "Switch company",
  "nav.logout": "Logout",
  "nav.expand": "Expand",
  "nav.collapse": "Collapse",
  "nav.expandMenu": "Expand the menu",
  "nav.collapseMenu": "Collapse the menu",
  "nav.openMenu": "Open menu",
  "nav.closeMenu": "Close menu",
  "nav.licenseExpired": "Your license has expired. The dashboard is read-only until it is renewed.",
  "nav.passwordLeaked": "Your password appears in a known data breach, so others may try it.",
  "nav.passwordLeakedChange": "Change it now under",
  "nav.rental": "Rental",
  "nav.inbox": "Inbox",
  "nav.inboxUnread": "Inbox, {count} unread",
  "nav.inboxReadAll": "Mark all as read",
  "nav.inboxEmpty": "Nothing here yet",
  "nav.pushRelay": "Push relay",
}

export default nav
